import React, { useEffect, useState } from 'react';
import BottomTab from "../Tab/BottomTab";
import { useTranslation } from "react-i18next";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import './DocumentDone.sass';
import { apiUser } from '../../basedata/apiCall';
import InfoModal from "../Modal/ModalInfo";
import { LinearProgress } from '@mui/material';
import { BsCardList } from "react-icons/bs";
import { BASE } from '../../basedata/constants';

interface Props {
    documentBase64: string;
    onResponse: (message: string) => void;
    documentAttempts: number;
    isVerse: boolean;
}

// well, sthepany needs to work on this
const WaBsCardList = BsCardList as React.ComponentType<React.SVGProps<SVGSVGElement>>;

let doc_check_retries = 0;
const DocumentDone = ({ documentBase64, onResponse, documentAttempts, isVerse }: Props) => {
    const { t } = useTranslation();
    const [isPanelOpen, setIsPanelOpen] = useState(true);
    const [loadingProgress, setLoadingProgress] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);


    const togglePanel = () => {
        setIsPanelOpen((prev) => !prev);
    };


    const simulateLoading = () => {
      setIsLoading(true);
      setLoadingProgress(0);
      const interval = setInterval(() => {
          setLoadingProgress((prev) => {
              if (prev >= 100) {
                  clearInterval(interval);
              }
              return prev + 1;
          });
      }, 900);
  };

  const handleConfirm = async () => {

    let retries = Number(sessionStorage.getItem('doc_retries') || 0);

    setIsLoading(true);
    setLoadingProgress(0);

    const interval = setInterval(() => {
      setLoadingProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
        }
        return prev + 1;
      });
    }, 900);
    const _document_front_image = sessionStorage.getItem('document_front_image') || null
    const token = sessionStorage.getItem('token') || 'na';
    const _has_back = sessionStorage.getItem('document_type') || 'cpf'
    
    if (_document_front_image || _has_back === 'passport') {

      let _document_check: any;
      if(_has_back === 'passport'){
      _document_check = await apiUser.post('/biometry/onboarding/face-match', {
        token,
        company_id: BASE.company.id,
        images: [documentBase64]
      });
      }else{
        _document_check = await apiUser.post('/biometry/onboarding/face-match', {
          token,
          company_id: BASE.company.id,
          images: [_document_front_image, documentBase64]
        });
      }


      retries += 1;
      sessionStorage.setItem('doc_retries', String(retries));

      if (_document_check?.data.success === true && _document_check?.data.message === 'done') {
        clearInterval(interval);
        window.location.href = '/success';
        return;
      }

      if (!_document_check?.data.success) {

        if(_document_check?.data.message === 'wrong_face'){
          setError_message('A sua selfie e a foto do documento não batem.')
          return setIsModalOpen(true);
        }else if(_document_check?.data.message === 'wrong_document'){
          setError_message('A imagem do documento inserido não confere com o número do documento do cadastro.')
          return setIsModalOpen(true);
        }else if(_document_check?.data.message === 'wrong_birthdate'){
          setError_message('A data de nascimento do cadastro e a data de nascimento do documento não batem')
          return setIsModalOpen(true);
        }else if(_document_check?.data.message === 'wrong_document_type'){
          setError_message('Não conseguimos identificar o tipo do documento enviado. Para finalizar, você pode enviar seu RG contendo o número do CPF ou sua CNH.')
          return setIsModalOpen(true);
        }

      }

      if (retries >= 4) {
        clearInterval(interval);
        window.location.href = '/waiting';
        return;
      }

      clearInterval(interval);
      setError_message(t('capture_document.error_messages.retries'));
      setIsModalOpen(true);
      return;
    }else{
      sessionStorage.setItem('document_front_image', documentBase64)
      clearInterval(interval);
      window.location.href = '/instructions-document?verse=true';
      return;
    }
  };

    const handleRetry = async () => {
      const _temp_token = sessionStorage.getItem('token')

      // if(isVerse){
      //  return onResponse('retry_back');
      // }
      const _validate_doc = await apiUser.get(`/biometry/onboarding/retry?uid=${_temp_token}`)
      sessionStorage.setItem('user_history', 'document_front')
      sessionStorage.removeItem('document_front_image')
      return window.location.href  = '/instructions'

    }
    
    const handleRecapture = () => {
      window.location.reload();
    };

    const titleKey = isVerse
        ? `well_done_document.verse_title_${documentAttempts + 1}` 
        : `well_done_document.front_title_${documentAttempts + 1}`;
    const messageKey = isVerse
        ? `well_done_document.verse_message_${documentAttempts + 1}`
        : `well_done_document.front_message_${documentAttempts + 1}`;

    const title = t(titleKey, t('well_done_document.front_default_title'));
    const message = t(messageKey, t('well_done_document.front_default_message'));


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [error_message, setError_message] = useState('A sua selfie e a foto do documento não batem.');
    const closeModal = () => {
      handleRetry()
      setIsModalOpen(false);
    };

    return (
        <div className="container-selfie-done">
           <InfoModal isOpen={isModalOpen} onClose={closeModal}>
                <h1>Opa!</h1>
                <p>{error_message}</p>
                <button className='button-retry-action' onClick={() => handleRetry()}>{t('success_document.try_again')}</button>
            </InfoModal>
            <InfoModal isOpen={showSuccessModal} onClose={() => setShowSuccessModal(false)}>
              <h1 className="modal-title-back">{t("modal_document_intructions.title_back")}</h1>
              <p className="modal-quote-back">{t("modal_document_intructions.quote_back")}</p>
              <p className="modal-quote-back-secondary">{t("modal_document_intructions.quote_back_2")}</p>
              <button
                className="retry-button inside-modal"
                onClick={() => {
                  setShowSuccessModal(false);
                  sessionStorage.removeItem('document_front_image');
                  window.location.href = '/instructions-document';
                }}
              >
                <span className="button-icon-label">
                  <WaBsCardList />
                  {t("modal_document_intructions.verse")}
                </span>
              </button>
            </InfoModal>


            <img src={documentBase64} alt="document" className="document-taken" />
            {!showSuccessModal && (
              isLoading ? (
                <div className="loader-container">
                  <LinearProgress color="secondary" />
                  <span className="loader-percentage">
                    {t("well_done_selfie.validating")}
                  </span>
                  <div className="loader-bar"></div>
                </div>
              ) : (
                <BottomTab togglePanel={togglePanel} isPanelOpen={isPanelOpen}>
                  <div className="selfie-confirmation-content">
                    <div className="selfie-confirmation-text">
                      <h1 className="selfie-confirmation-title">
                        {t("well_done_selfie.review_title")}
                      </h1>
                      <p className="selfie-confirmation-paragraph">
                        {t("modals.everything_ok.message")}
                      </p>
                      <p className="selfie-confirmation-paragraph-doc">
                        {t("modals.everything_ok.message_2")}
                      </p>
                    </div>
                    <div className="try-again-section">
                      <button onClick={handleConfirm}>
                        {t("success_selfie.send_document")}
                      </button>
                      <div className="try-again-link" onClick={handleRecapture}>
                        <ArrowBackIcon />
                        <p>{t("well_done_selfie.try_again")}</p>
                      </div>
                    </div>
                  </div>
                </BottomTab>
              )
            )}
        </div>
    );
};

export default DocumentDone;